<template>
  <v-container>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ texto }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout>
      <v-autocomplete
        label="Pesquisar usuário"
        prepend-inner-icon="mdi-magnify"
        solo
        single-line
        no-filter
        :items="users"
        :item-text="usuarios_name"
        :item-value="usuario_id"
        v-model="user_selected"
        hide-details
        no-data-text="Digite qualquer parte do nome do usuário"
        :search-input.sync="search"
      ></v-autocomplete>
    </v-layout>
    <v-layout>
      <v-row align="center">
        <v-card class="mx-auto mt-4" max-width="800">
          <v-list
            :disabled="disabled"
            :dense="dense"
            :two-line="twoLine"
            :three-line="threeLine"
            :shaped="shaped"
            :flat="flat"
            :subheader="subheader"
            :inactive="inactive"
            :sub-group="subGroup"
            :nav="nav"
            :avatar="avatar"
            :rounded="rounded"
            v-for="(item, i) in items"
            :key="i"
          >
            <v-subheader v-html="item.funcao.nome"></v-subheader>
            <v-list-item-group color="primary">
              <v-list-item>
                <v-checkbox
                  true-value="S"
                  false-value="N"
                  v-model="item.c"
                  class="pl-4"
                ></v-checkbox>
                <v-list-item-title
                  style="width: 300px"
                  v-text="funcoes.name1"
                ></v-list-item-title>
                <v-checkbox
                  true-value="S"
                  false-value="N"
                  v-model="item.u"
                  class="pl-4"
                ></v-checkbox>
                <v-list-item-title v-text="funcoes.name2"></v-list-item-title>
                <v-checkbox
                  true-value="S"
                  false-value="N"
                  v-model="item.r"
                  class="pl-4"
                ></v-checkbox>
                <v-list-item-title v-text="funcoes.name3"></v-list-item-title>
                <v-checkbox
                  true-value="S"
                  false-value="N"
                  v-model="item.d"
                  class="pl-4"
                ></v-checkbox>
                <v-list-item-title v-text="funcoes.name4"></v-list-item-title>
                <v-checkbox
                  true-value="S"
                  false-value="N"
                  v-model="item.a"
                  class="pl-4"
                ></v-checkbox>
                <v-list-item-title v-text="funcoes.name5"></v-list-item-title>
                <v-checkbox
                  true-value="S"
                  false-value="N"
                  v-model="item.e"
                  class="pl-4"
                ></v-checkbox>
                <v-list-item-title v-text="funcoes.name6"></v-list-item-title>
              </v-list-item>
            </v-list-item-group>
            <v-divider></v-divider>
          </v-list>
          <v-btn
            color="primary"
            class="ml-4 mb-4 mr-4"
            :loading="botao_loading"
            @click="atualizar_autorizacoes"
            v-show="mostrar_botao"
          >
            Salvar
          </v-btn>
          <v-btn
            @click="restaurar"
            class="ml-4 mb-4 mr-4"
            color="primary"
            v-show="mostrar_botao"
            :loading="load_restaurar"
            >Restaurar</v-btn
          >
        </v-card>
      </v-row>
    </v-layout>
  </v-container>
</template>
<script>
import { Pessoa, Autorizacao } from '../../service'

// import Axios from 'axios'
/* eslint-disable */
export default {
  data: () => ({
    users: [],
    user_selected: null,
    user_loading: false,
    salvou: false,
    search: null,
    funcoes: {
      name1: 'Criar',
      name2: 'Atualizar',
      name3: 'Visualizar',
      name4: 'Excluir',
      name5: 'Autorizar',
      name6: 'Enviar'
    },
    items: [],
    disabled: false,
    dense: false,
    twoLine: false,
    threeLine: false,
    shaped: false,
    flat: false,
    subheader: false,
    inactive: false,
    subGroup: false,
    nav: false,
    avatar: false,
    rounded: false,
    escola: localStorage.getItem('escola')
      ? localStorage.getItem('escola')
      : '',
    botao_loading: null,
    timeout: 500,
    snackbar: false,
    mostrar_botao: false,
    id_search: null,
    load_restaurar: false,
    texto: '',
    delay: 500
  }),
  watch: {
    user_selected: {
      handler(user_selected) {
        if (user_selected > 0){
          this.getAutorizacoes()
        }else{
          this.mostrar_botao = false
          this.items = []
        }
      }
    },
    search: {
      deep: true,
      /* eslint-disable */
      handler() {
        clearTimeout(this.delay)
        if (this.search) {
          if (this.search.length > 2){
            this.user_loading = true
            this.delay = setTimeout(() => this.getUsuario(), 750)
            this.user_loading = false
          }
        }else{
          this.users = []
          this.mostrar_botao = false
          this.items = []
        }
      }
    }
  },
  methods: {
    usuarios_name(user) {
      return `${user.nome}`
    },
    usuario_id(user) {
      return `${user.user.id}`
    },
    async atualizar_autorizacoes() {
      this.botao_loading = true
      const res = await Autorizacao.create(this.items, { escola: this.escola })
      this.botao_loading = false
      this.snackbar = true
      this.texto = ' Autorizações alteradas com sucesso!'
    },
    async restaurar() {
      this.load_restaurar = true
      this.items = await Autorizacao.findById(this.user_selected, {
        escola: this.escola
      })
      this.load_restaurar = false
      this.snackbar = true
      this.texto = 'Autorizações restauradas!'
    },
    async getUsuario() {
      this.users = await Pessoa.filter({
        search: this.search,
        escola: this.escola
      })
    },
    async getAutorizacoes() {
      this.items = await Autorizacao.findById(this.user_selected, {
        escola: this.escola
      })
      this.mostrar_botao = true
    }
  }
}
</script>

<style lang="stylus" scoped></style>
